import { Component, input, signal } from "@angular/core";
import { AddClassModifierDirective } from "src/app/core/directives/add-class-modifier.directive";
import { NavGroup, NavItem } from "src/models/nav";
import { AppService } from "src/services/app.service";
import { NavItemComponent } from "../nav-item/nav-item.component";

@Component({
  selector: "app-nav-group",
  templateUrl: "./nav-group.component.html",
  styleUrl: "./nav-group.component.scss",
  imports: [AddClassModifierDirective, NavItemComponent],
})
export class NavGroupComponent {
  isSideBarCollapsed = this.appService.isSideBarCollapsed;
  readonly items = input<NavItem[]>();
  readonly group = input<NavGroup>();
  readonly showChildren = signal(true);

  constructor(private appService: AppService) {}

  toggleChildren() {
    this.showChildren.set(!this.showChildren());
  }
}
